import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, Card, CardBody } from "reactstrap";

const PaymentsRefundPolicy = () => {
  document.title = "Payments & Refund Policy | Porcher";

  return (
    <div className="page-content">
      <Container>
        <Row className="justify-content-center">
          <Col lg={8}>
            <Card className="border-0 shadow-sm mt-4">
              <CardBody className="p-4">
                <h1 className="mb-3">Payments &amp; Refund Policy</h1>
                <p className="text-muted small mb-4">Last updated: August 22, 2026</p>

                <div className="content">
                  <h5 className="mt-4">1. Overview</h5>
                  <p>
                    Patronage Reservoir LLC, a Nevada limited liability company doing business as Porcher ("Porcher",
                    "we", "our", or "us"), uses Stripe to process payments on the Platform, including rental
                    application fees and rent payments. This policy describes how those payments work and how refunds
                    and disputes are handled. It is incorporated by reference into our{" "}
                    <Link to="/terms-of-service">Terms of Service</Link>.
                  </p>

                  <h5 className="mt-4">2. Payment Processing</h5>
                  <p>
                    All card and bank payments on the Platform are processed by Stripe. Porcher does not store your
                    full card number or bank account number — that information is held by Stripe, subject to Stripe's
                    own security standards and terms.
                  </p>

                  <h5 className="mt-4">3. Rental Application Fees</h5>
                  <p>
                    An Applicant may be charged a one-time application fee, disclosed before payment, to submit a
                    rental application for review and, where applicable, to initiate a screening request. Because this
                    fee covers costs (including third-party screening costs) that are incurred as soon as the
                    application is submitted, application fees are generally non-refundable once the application has
                    been submitted or a screening report has been requested — except where required by law, or where
                    the fee was charged in error (for example, a duplicate charge or a listing that was removed before
                    any screening was requested).
                  </p>

                  <h5 className="mt-4">4. Rent Payments</h5>
                  <p>
                    Tenants pay rent through the Platform's payment form, and funds are transferred to the
                    Homeowner's connected Stripe account. Payment timing, processing, and payout schedules are subject
                    to Stripe's standard processing times. If a rent payment is declined or fails, the Tenant will
                    need to retry the payment — Porcher is not responsible for a Tenant's insufficient funds or a
                    declined payment method.
                  </p>

                  <h5 className="mt-4">5. Manual / Off-Platform Payments</h5>
                  <p>
                    A Homeowner may log a cash, check, or other off-platform payment on the Platform for their own
                    recordkeeping. Porcher does not process, hold, or guarantee the collection of these funds — the
                    record exists only to help the Homeowner track their rent roll.
                  </p>

                  <h5 className="mt-4">6. Fees &amp; Pricing Disclosure</h5>
                  <p>
                    Any fee Porcher charges — including application fees and any escalation or expedited-handling fee
                    described below — is disclosed to you before you are charged. We do not add undisclosed fees to a
                    payment after the fact.
                  </p>

                  <h5 className="mt-4">7. Refund Requests</h5>
                  <p>
                    To request a refund, contact us through the support portal with the payment details and the
                    reason for your request. We review refund requests individually; where a refund is approved, it
                    is returned to the original payment method through Stripe and may take several business days to
                    appear, depending on your bank or card issuer.
                  </p>

                  <h5 className="mt-4">8. Payment Disputes &amp; Chargebacks</h5>
                  <p>
                    If you have a question or disagreement about a charge, please contact us through the support
                    portal before filing a dispute or chargeback with your bank or card issuer — most issues can be
                    resolved faster that way. If a chargeback is filed, we will cooperate with Stripe and provide
                    relevant records; chargebacks found to be unwarranted (for example, for a service that was
                    actually delivered) may result in restrictions on your ability to use the Platform's payment
                    features.
                  </p>

                  <h5 className="mt-4">9. Escalation Fees</h5>
                  <p>
                    If you ask us to expedite or escalate handling of a payment dispute or support matter that
                    requires additional manual review, we may charge a fee for that specific service. Any such fee is
                    disclosed to you and requires your confirmation before you are charged, and is non-refundable once
                    the requested review or work has been performed.
                  </p>

                  <h5 className="mt-4">10. Landlord Payouts</h5>
                  <p>
                    To receive rent payments collected through the Platform, a Homeowner must complete onboarding with
                    Stripe Connect, including identity verification required by Stripe and applicable law. Payout
                    timing, holds, and verification requirements are governed by Stripe, not by Porcher.
                  </p>

                  <h5 className="mt-4">11. Taxes</h5>
                  <p>
                    Homeowners are solely responsible for determining and paying any taxes owed on rent or other
                    income received through the Platform. Porcher does not provide tax advice and does not withhold
                    taxes on your behalf unless required by law.
                  </p>

                  <h5 className="mt-4">12. Changes to This Policy</h5>
                  <p>
                    We may update this Payments &amp; Refund Policy from time to time. Continued use of the Platform's
                    payment features after an update means you accept the revised policy.
                  </p>

                  <h5 className="mt-4">13. Contact Us</h5>
                  <p>
                    If you have questions about this Payments &amp; Refund Policy, please contact us through the
                    support portal.
                  </p>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default PaymentsRefundPolicy;
